import { depascalize, DropdownOption, getEnumValues } from "sprint-common-web";

export enum DynamicSubtitleType {
    Zip = 1,
    Dvb = 2,
    Srt = 3,
    Txt = 4,
    Vtt = 5,
    Ssa = 6,
    Scc = 7,
    VttIndexed = 8
}

export const dynamicSubtitleTypeDropdownOptions = getEnumValues(DynamicSubtitleType).map<DropdownOption>((type) => ({
    key: type.toString(),
    text: depascalize(DynamicSubtitleType[type])
}));

export const mapNumberToDynamicSubtitleType = (typeNumber: number): DynamicSubtitleType => {
    ensureNumberAssignableToType(typeNumber);

    return typeNumber;
};

const ensureNumberAssignableToType = (typeNumber: number): typeNumber is DynamicSubtitleType => {
    if (!isNumberDynamicSubtitleType(typeNumber)) {
        throw new Error(`Dynamic Subtitle type '${typeNumber}' is incorrect.`);
    }

    return true;
};

const isNumberDynamicSubtitleType = (typeNumber: number) => getEnumValues(DynamicSubtitleType).includes(typeNumber);
